import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalEdit: false,
    data: {}
  },

  mutations: {
    TModal(state, value) {
      state.ModalEdit = value
    },

    VData(state, value) {
      state.data = value
    },
  }
})